export const getLocalizedRichText = async (locale) => {
  try {
    const response = await fetch(`locales/globals/${locale}.json`);
    const localeData = await response.json();
    return localeData;
  }
  catch (err) {
    console.error(`Could not fetch the translation file locales/globals/${locale}.json`, err);
  }
}

export const getLocalizedRichTextContent = async (filePath) => {
  try {
    const response = await fetch(`locales/md/${filePath}`);
    const content = await response.text();
    return content;
  }
  catch (err) {
    console.error(`An error occurred when getting the translation file for locales/md/${filePath}`, err);
  }
}